module.exports = __webpack_public_path__ + "static/img/certificate_img29.8b1b9af2.jpg";